(() => {
  'use strict';

  let modal = null, overlay = null, currentData = null, currentQty = 1;

  // Cap disponibilita': quante unita' della variante si possono ancora
  // aggiungere. Shopify (verificato empiricamente su questo store) accetta
  // add oltre lo stock anche con policy deny e blocca solo al checkout:
  // il controllo va fatto a monte, qui. Dati: JSON .amotea-inv-data
  // embeddato nelle card + quantita' gia' in carrello (/cart.js).
  function remainingFor(variant) {
    if (!currentData) return Infinity;
    const inv = currentData._amoteaInv && currentData._amoteaInv[variant.id];
    if (!inv || !inv.managed || String(inv.policy).toLowerCase() !== 'deny') return Infinity;
    const inCart = (currentData._inCart && currentData._inCart[variant.id]) || 0;
    return Math.max(0, inv.qty - inCart);
  }

  function buildModal() {
    if (modal) return;

    overlay = document.createElement('div');
    overlay.className = 'amotea-qo-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeModal);

    modal = document.createElement('div');
    modal.className = 'amotea-qo-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick options');
    modal.innerHTML = `
      <button class="amotea-qo-close" aria-label="Close" type="button">&#215;</button>
      <div class="amotea-qo-body">
        <div class="amotea-qo-image-col">
          <img class="amotea-qo-image" src="" alt="" width="400" height="500" loading="lazy">
        </div>
        <div class="amotea-qo-detail-col">
          <p  class="amotea-qo-vendor"></p>
          <h2 class="amotea-qo-title"></h2>
          <p  class="amotea-qo-price"></p>
          <div class="amotea-qo-options"></div>
          <div class="amotea-qo-qty-row" role="group" aria-label="Quantity">
            <button class="amotea-qo-qty-btn amotea-qo-qty-minus" type="button" aria-label="Decrease">−</button>
            <span class="amotea-qo-qty-value" aria-live="polite">1</span>
            <button class="amotea-qo-qty-btn amotea-qo-qty-plus"  type="button" aria-label="Increase">+</button>
          </div>
          <button class="amotea-qo-add" type="button">Add to bag</button>
          <p class="amotea-qo-error" role="alert" hidden></p>
          <a class="amotea-qo-full-link" href="#">View full details →</a>
          <p class="amotea-qo-desc"></p>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    modal.querySelector('.amotea-qo-close').addEventListener('click', closeModal);

    // La quantità è un nodo di testo, non un input: immune per costruzione
    // da bug di rendering degli input, autofill, traduzione automatica ed
    // estensioni. Stato in currentQty, visualizzato nello span.
    const renderQty = () => {
      modal.querySelector('.amotea-qo-qty-value').textContent = String(currentQty);
    };
    modal.querySelector('.amotea-qo-qty-minus').addEventListener('click', () => {
      currentQty = Math.max(1, currentQty - 1);
      renderQty();
    });
    modal.querySelector('.amotea-qo-qty-plus').addEventListener('click', () => {
      const addBtn = modal.querySelector('.amotea-qo-add');
      const variant = currentData && currentData.variants.find(v => v.id === parseInt(addBtn.dataset.variantId));
      const cap = variant ? Math.min(99, remainingFor(variant)) : 99;
      const errEl = modal.querySelector('.amotea-qo-error');
      if (currentQty + 1 > cap) {
        errEl.textContent = 'Only ' + cap + ' available' + ((currentData._inCart && currentData._inCart[variant.id]) ? ' (some already in your bag)' : '');
        errEl.hidden = false;
        return;
      }
      errEl.hidden = true;
      currentQty = Math.min(99, currentQty + 1);
      renderQty();
    });

    modal.querySelector('.amotea-qo-add').addEventListener('click', handleAddToBag);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('amotea-qo-modal--open')) closeModal();
    });
  }

  function openModal(product) {
    buildModal();
    currentData = product;

    const firstVariant  = product.variants[0];
    const featuredImage = product.featured_image;

    const imgEl = modal.querySelector('.amotea-qo-image');
    if (featuredImage) {
      imgEl.src = featuredImage.replace(/(\.\w+)$/, '_600x750$1');
      imgEl.alt = product.title;
    }

    modal.querySelector('.amotea-qo-vendor').textContent   = product.vendor || '';
    modal.querySelector('.amotea-qo-title').textContent    = product.title;
    modal.querySelector('.amotea-qo-full-link').href       = product.url;

    const available = product.variants.find(v => v.available) || firstVariant;
    updatePrice(available);

    const rawDesc = (product.description || '').replace(/<[^>]+>/g, '').trim();
    modal.querySelector('.amotea-qo-desc').textContent =
      rawDesc.length > 160 ? rawDesc.slice(0, 160).trimEnd() + '…' : rawDesc;

    currentQty = 1;
    modal.querySelector('.amotea-qo-qty-value').textContent = '1';
    modal.querySelector('.amotea-qo-error').hidden = true;
    // per ultimo: puo' impostare messaggi di disponibilita' che devono restare
    buildOptions(product);

    overlay.classList.add('amotea-qo-overlay--open');
    modal.classList.add('amotea-qo-modal--open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => modal.querySelector('.amotea-qo-close').focus(), 50);
  }

  function closeModal() {
    if (!modal) return;
    overlay.classList.remove('amotea-qo-overlay--open');
    modal.classList.remove('amotea-qo-modal--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentData = null;
  }

  // L'endpoint AJAX /products/<handle>.js espone `options` come
  // [{name, position, values}] (mai `options_with_values`, che è solo Liquid).
  // Normalizza entrambe le forme e, se mancano i values, li deriva dalle varianti.
  function getOptionData(product) {
    const raw = product.options_with_values || product.options || [];
    return raw.map((opt, i) => {
      const name = typeof opt === 'string' ? opt : (opt.name || 'Option ' + (i + 1));
      let values = (opt && opt.values) ? opt.values.slice() : [];
      if (!values.length) {
        const seen = new Set();
        product.variants.forEach(v => {
          const val = variantOptions(v)[i];
          if (val != null && !seen.has(val)) { seen.add(val); values.push(val); }
        });
      }
      return { name: name, values: values };
    }).filter(o => o.values.length);
  }

  function variantOptions(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(x => x != null);
  }

  function buildOptions(product) {
    const container = modal.querySelector('.amotea-qo-options');
    container.innerHTML = '';
    const optionData = getOptionData(product);
    if (!optionData.length || product.variants.length <= 1) return;

    // preseleziona le opzioni della prima variante disponibile
    const preferred = product.variants.find(v => v.available) || product.variants[0];
    const preferredVals = variantOptions(preferred);

    optionData.forEach((opt, optIndex) => {
      const isColor = /colou?r|colore/i.test(opt.name);
      const group   = document.createElement('div');
      group.className = 'amotea-qo-option-group';

      const label = document.createElement('div');
      label.className = 'amotea-qo-option-label';
      label.textContent = opt.name;
      group.appendChild(label);

      const btns = document.createElement('div');
      btns.className = isColor ? 'amotea-qo-option-swatches' : 'amotea-qo-option-sizes';

      opt.values.forEach((val, valIndex) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.option = optIndex;
        btn.dataset.value  = val;
        btn.setAttribute('aria-label', val);

        if (isColor) {
          btn.className = 'amotea-qo-swatch';
          btn.style.backgroundColor = val.toLowerCase().replace(/\s+/g, '');
          btn.title = val;
        } else {
          btn.className   = 'amotea-qo-size-btn';
          btn.textContent = val;
        }

        const isPreferred = preferredVals[optIndex] != null
          ? val === preferredVals[optIndex]
          : valIndex === 0;
        if (isPreferred) btn.classList.add('is-active');

        btn.addEventListener('click', () => {
          btns.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          updateSelectedVariant(product);
        });

        btns.appendChild(btn);
      });

      group.appendChild(btns);
      container.appendChild(group);
    });

    // sincronizza prezzo, variantId e stato del bottone con la preselezione
    updateSelectedVariant(product);
  }

  // Attenua i valori senza variante disponibile (coerente con la PDP):
  // per ogni bottone simula la selezione corrente con quel valore e
  // verifica se esiste una variante acquistabile.
  function markAvailability(product, selected) {
    modal.querySelectorAll('.amotea-qo-options button').forEach(btn => {
      const candidate = Object.assign({}, selected);
      candidate[parseInt(btn.dataset.option)] = btn.dataset.value;
      const match = product.variants.find(v => {
        const vopts = variantOptions(v);
        return Object.entries(candidate).every(([i, val]) => vopts[parseInt(i)] === val);
      });
      btn.classList.toggle('amotea-qo-opt--soldout', !match || !match.available);
    });
  }

  function updateSelectedVariant(product) {
    const selected = {};
    modal.querySelectorAll('.amotea-qo-options button.is-active').forEach(btn => {
      selected[parseInt(btn.dataset.option)] = btn.dataset.value;
    });
    markAvailability(product, selected);
    const variant = product.variants.find(v => {
      const vopts = variantOptions(v);
      return Object.entries(selected).every(([i, val]) => vopts[parseInt(i)] === val);
    });
    if (variant) {
      updatePrice(variant);
    } else {
      const addBtn = modal.querySelector('.amotea-qo-add');
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      delete addBtn.dataset.variantId;
      addBtn.textContent = 'Unavailable';
    }
  }

  function updatePrice(variant) {
    if (!variant) return;
    const priceEl = modal.querySelector('.amotea-qo-price');

    if (window.Shopify && window.Shopify.formatMoney) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          `<span class="amotea-qo-price-sale">${Shopify.formatMoney(variant.price)}</span>` +
          `<s class="amotea-qo-price-compare">${Shopify.formatMoney(variant.compare_at_price)}</s>`;
      } else {
        priceEl.textContent = Shopify.formatMoney(variant.price);
      }
    }

    const addBtn = modal.querySelector('.amotea-qo-add');
    addBtn.dataset.variantId = variant.id;

    const remaining = remainingFor(variant);
    const errEl = modal.querySelector('.amotea-qo-error');
    if (!variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
    } else if (remaining === 0) {
      addBtn.disabled = true;
      addBtn.textContent = 'Add to bag';
      errEl.textContent = 'All available items are already in your bag';
      errEl.hidden = false;
    } else {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to bag';
      if (currentQty > remaining) { currentQty = Math.max(1, remaining); modal.querySelector('.amotea-qo-qty-value').textContent = String(currentQty); }
      errEl.hidden = true;
    }
    addBtn.setAttribute('aria-disabled', addBtn.disabled ? 'true' : 'false');
  }

  async function handleAddToBag() {
    const addBtn    = modal.querySelector('.amotea-qo-add');
    const variantId = parseInt(addBtn.dataset.variantId);
    if (!variantId || addBtn.disabled) return;

    // ultima rete di sicurezza: mai chiedere piu' del disponibile residuo
    const variant = currentData && currentData.variants.find(v => v.id === variantId);
    if (variant) {
      const rem = remainingFor(variant);
      if (rem !== Infinity && currentQty > rem) currentQty = Math.max(1, rem);
    }

    addBtn.disabled = true;
    const original  = addBtn.textContent;
    addBtn.textContent = '...';

    const errEl = modal.querySelector('.amotea-qo-error');
    errEl.hidden = true;

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: currentQty || 1 })
      });
      if (!res.ok) {
        // Shopify risponde 422 con una descrizione (es. quantita' oltre
        // la disponibilita', "All N items are in your cart"): mostrala.
        let msg = 'Unable to add to bag';
        try {
          const err = await res.json();
          msg = err.description || err.message || msg;
        } catch (_) { /* body non JSON */ }
        errEl.textContent = msg;
        errEl.hidden = false;
        throw new Error(msg);
      }

      addBtn.textContent = 'Added!';
      // Eventi nativi Symmetry (cart-drawer.js:11-13): refresh contenuto + apertura
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(() => {
        closeModal();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }, 600);

    } catch (_) {
      addBtn.textContent = original;
      addBtn.disabled    = false;
    }
  }

  function initCards() {
    document.querySelectorAll('.product-block:not([data-qo-init])').forEach(card => {
      card.setAttribute('data-qo-init', '1');

      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const productUrl    = link.getAttribute('href');
      const hoverOverlay  = document.createElement('div');
      hoverOverlay.className = 'amotea-qo-card-overlay';

      const chooseBtn = document.createElement('button');
      chooseBtn.type      = 'button';
      chooseBtn.className = 'amotea-qo-choose-btn';
      chooseBtn.textContent = 'Choose options';

      hoverOverlay.appendChild(chooseBtn);

      // .image-cont è il wrapper reale in Symmetry (product-block.liquid:96) e non
      // viene mai messo a opacity:0 dal tema; .product-block__image--primary sì
      // (hover-swap immagine secondaria, main.css:9701) e nascondeva il pulsante.
      const imageWrapper = card.querySelector('.image-cont')
        || card.querySelector('.product-block__image-link, .product-block__image');
      if (imageWrapper) {
        imageWrapper.style.position = 'relative';
        imageWrapper.appendChild(hoverOverlay);
      }

      chooseBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          const res     = await fetch(productUrl.split('?')[0] + '.js');
          if (!res.ok) throw new Error();
          const product = await res.json();

          // dati magazzino embeddati nella card (snippets product-block)
          product._amoteaInv = {};
          try {
            const invEl = card.querySelector('.amotea-inv-data');
            if (invEl) JSON.parse(invEl.textContent).forEach(r => { product._amoteaInv[r.id] = r; });
          } catch (_) { /* senza dati: nessun cap */ }

          // quantita' gia' in carrello per variante
          product._inCart = {};
          try {
            const cart = await (await fetch('/cart.js')).json();
            cart.items.forEach(i => { product._inCart[i.variant_id] = (product._inCart[i.variant_id] || 0) + i.quantity; });
          } catch (_) { /* senza carrello: nessun cap aggiuntivo */ }

          openModal(product);
        } catch (_) {
          window.location.href = productUrl;
        }
      });
    });
  }

  function init() {
    initCards();
    document.addEventListener('shopify:section:load', initCards);
    document.addEventListener('collection:reloaded', initCards);

    if ('MutationObserver' in window) {
      const grid = document.querySelector('.product-list, .collection-grid, .product-grid');
      if (grid) new MutationObserver(initCards).observe(grid, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
